import React from 'react';
import { FadeIn, Button, CountdownTimer } from './Shared';
import { Check } from 'lucide-react';
export const PricingSection = () => {
  return <section id="pricing" className="py-8 md:py-12 px-4 bg-navy-800/50 relative overflow-hidden" data-id="element-199">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-3xl h-96 bg-gold-500/5 blur-[120px] rounded-full pointer-events-none" data-id="element-200"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-201">
        <FadeIn data-id="element-202">
          <div className="text-center mb-12" data-id="element-203">
            <h2 className="text-sm font-bold tracking-widest text-red-400 uppercase mb-6" data-id="element-204">
              ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
            </h2>
            <CountdownTimer data-id="element-205" />
            <p className="text-gray-400 mt-6 font-medium" data-id="element-206">
              ⚠️ Después sube $5.000 ARS. No vuelve.
            </p>
            <h3 className="text-3xl md:text-4xl font-serif font-bold text-white mt-10 mb-4" data-id="element-207">
              ELEGÍ TU MEGAPACK
            </h3>
          </div>

          <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-208">
            {/* Standard Card */}
            <div className="bg-navy-900 rounded-3xl border border-navy-700 p-8 flex flex-col hover:border-gold-500/30 transition-all pt-[20px] pb-[20px]" data-id="element-209">
              <div className="mb-6" data-id="element-210">
                <h4 className="text-2xl font-serif font-bold text-white mb-2" data-id="element-211">
                  🌙 MEGAPACK NOCHES DE PAZ
                </h4>
                <p className="text-gray-400" data-id="element-212">
                  5 Tomos + 5 Bonos · 0 a 36 meses
                </p>
              </div>
              <div className="mb-8" data-id="element-213">
                <span className="text-gray-500 line-through text-xl mr-3" data-id="element-214">
                  $61.000
                </span>
                <span className="text-4xl font-bold text-gold-400" data-id="element-215">
                  $19.990 <span className="text-lg text-gray-400" data-id="element-216">ARS</span>
                </span>
              </div>
              <ul className="space-y-4 mb-8 flex-grow text-gray-300" data-id="element-217">
                <li className="flex items-start" data-id="element-218">
                  <Check className="w-5 h-5 text-gold-400 mr-3 shrink-0" data-id="element-219" />{' '}
                  <span data-id="element-220">Los 5 Tomos del Sistema</span>
                </li>
                <li className="flex items-start" data-id="element-221">
                  <Check className="w-5 h-5 text-gold-400 mr-3 shrink-0" data-id="element-222" />{' '}
                  <span data-id="element-223">Los 5 Bonos Exclusivos</span>
                </li>
                <li className="flex items-start" data-id="element-224">
                  <Check className="w-5 h-5 text-gold-400 mr-3 shrink-0" data-id="element-225" />{' '}
                  <span data-id="element-226">Acceso Inmediato y de por vida</span>
                </li>
              </ul>
              <Button href="https://mundopractico.online/cart/48588077203673:1" className="w-full py-4 md:py-5 text-base md:text-lg" data-id="element-227">
                → QUIERO MI MEGAPACK AHORA
              </Button>
            </div>

            {/* Premium Card */}
            <div className="bg-gradient-to-b from-navy-800 to-navy-900 rounded-3xl border-2 border-gold-500/50 p-8 flex flex-col relative transform md:-translate-y-4 shadow-2xl shadow-gold-500/10" data-id="element-228">
              <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-gold-500 text-navy-900 font-bold px-4 py-1 rounded-full text-sm" data-id="element-229">
                MÁS ELEGIDO
              </div>
              <div className="mb-6" data-id="element-230">
                <h4 className="text-2xl font-serif font-bold text-white mb-2" data-id="element-231">
                  🏆 MEGAPACK + RECONEXIÓN ⭐
                </h4>
                <p className="text-gray-400" data-id="element-232">
                  5 Tomos + 5 Bonos + Guía de Pareja Post-Caos
                </p>
              </div>
              <div className="mb-8" data-id="element-233">
                <span className="text-gray-500 line-through text-xl mr-3" data-id="element-234">
                  $79.000
                </span>
                <span className="text-4xl font-bold text-gold-400" data-id="element-235">
                  $27.990 <span className="text-lg text-gray-400" data-id="element-236">ARS</span>
                </span>
              </div>
              <ul className="space-y-4 mb-8 flex-grow text-gray-300" data-id="element-237">
                <li className="flex items-start" data-id="element-238">
                  <Check className="w-5 h-5 text-gold-400 mr-3 shrink-0" data-id="element-239" />{' '}
                  <span data-id="element-240">Todo lo del MegaPack Básico</span>
                </li>
                <li className="flex items-start" data-id="element-241">
                  <Check className="w-5 h-5 text-gold-400 mr-3 shrink-0" data-id="element-242" />{' '}
                  <span className="font-bold text-white" data-id="element-243">
                    Guía: Reconexión de Pareja Post-Caos
                  </span>
                </li>
                <li className="flex items-start" data-id="element-244">
                  <Check className="w-5 h-5 text-gold-400 mr-3 shrink-0" data-id="element-245" />{' '}
                  <span className="font-bold text-white" data-id="element-246">
                    Plantilla de división de turnos nocturnos
                  </span>
                </li>
              </ul>
              <Button href="https://mundopractico.online/cart/48588081660121:1" className="w-full py-4 md:py-5 text-base md:text-lg" data-id="element-247">
                → QUIERO EL MEGAPACK + RECONEXIÓN
              </Button>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};